module.exports = "<h2 mat-dialog-title>Agregar Miembro</h2>\n<mat-dialog-content>\n  <form>\n    <mat-form-field>\n      <input #nombre matInput placeholder=\"Nombre del nuevo miembro\" value=\"\">\n    </mat-form-field>\n  </form>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-button mat-dialog-close>Cancelar</button>\n  <button mat-button [mat-dialog-close]=\"nombre.value\">Aceptar</button>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nuevo-miembro/nuevo-miembro.component.html
// module id = ./src/app/nuevo-miembro/nuevo-miembro.component.html
// module chunks = main